import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/dashboard/documents";

export const Route = createFileRoute("/dashboard/documents")({
  component: Page,
});
